(() => {
  if (window.guardAccountSessionStarted) return;
  window.guardAccountSessionStarted = true;
  if (!['www.expertfxhub.com', 'expertfxhub.com'].includes(location.hostname)) return;
  let running = false;
  function render(initial = '') {
    document.querySelectorAll('[data-guard-account]').forEach(link => {
      const avatar = link.querySelector('[data-guard-avatar]');
      const icon = link.querySelector('.icon-account');
      if (!avatar || !icon) return;
      avatar.textContent = initial;
      avatar.hidden = !initial;
      icon.style.display = initial ? 'none' : '';
      const label = initial ? link.dataset.signedLabel : link.dataset.guestLabel;
      link.setAttribute('aria-label', label);
      link.querySelectorAll('[data-guard-account-label], .guard-account-tooltip').forEach(node => { node.textContent = label; });
    });
  }
  async function refresh() {
    if (running || document.hidden) return;
    running = true;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch('https://portal.expertfxhub.com/account/session', {credentials: 'include', cache: 'no-store', signal: controller.signal});
      if (!response.ok) throw Error('Session unavailable');
      const state = await response.json();
      render(state.authenticated === true && typeof state.initial === 'string' && /^[\p{L}\p{N}]{1,3}$/u.test(state.initial) ? state.initial : '');
    } catch { render(); }
    finally { clearTimeout(timer); running = false; }
  }
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', refresh);
  setInterval(refresh, 60000);
  refresh();
})();
